import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=2174b95a&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"
import style0 from "./Color.vue?vue&type=style&index=0&id=2174b95a&prod&lang=scss"
import style1 from "./Color.vue?vue&type=style&index=1&id=2174b95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174b95a",
  null
  
)

export default component.exports